export default {
    auth: {
        registration: {
            title: 'Sign Up',
            alreadyAMember: 'Already have an account? ',
            message: '',
            signIn: 'Sign in',
            confirm: 'Continue',
            successMessage: 'Please check your mailbox and verify email',
            errorMessage: 'Invalid email address or password',
        },
        confirmEmail: {
            title: 'Email confirmation',
            message:
                'Enter the verification code we sent to your email address below.',
            messageBottom: '',
            button: 'CONFIRM',
            buttonResend: 'RESEND VERIFICATION CODE',
            successMessage: '',
            errorMessage:
                'Oops! It looks like you might have entered the wrong verification code. Give it another try.',
        },
        login: {
            title: 'Sign In',
            button: 'Login',
            link: 'Reset password',
            signUpNow: 'Sign up now',
            errorMessage: 'Invalid email address or password',
        },
        forgotPassword: {
            title: 'Password reset',
            button: 'Reset',
            link: 'Back to Sign in page',
            successMessage: 'Password has been reset',
        },
        resetPassword: {
            title: 'Confirm new password',
            button: 'Reset',
            successMessage: 'Password has been confirmed',
        },
    },
};
